import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { useEffect } from "react";
import baseUrl from "../../../api/universalApi";

const ESCALATION_POINTS = [
  "Agreement Signed",
  "Invoice Opened",
  "Invoice Approved",
  "Sent to Finance",
  "Processed",
  "Paid to Creator",
];

const FIELD_KEYS = [
  "Agreement_Signed",
  "Invoice_Opened",
  "Invoice_Approved",
  "Sent_to_Finance",
  "Processed",
  "Paid_to_Creator",
];

const Escalations = ({ campaignId }) => {
  //console.log("campaignId", campaignId)
  const [popup, setPopup] = useState(false);
  const [escalationData, setEscalationData] = useState(null);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [form, setForm] = useState({
    escalation_reason: "",
    escalation_count: "",
    escalation_time: "",
    escalation_status: "",
  });
  const [loading, setLoading] = useState(false);

  const handleEscalate = (idx) => {
    setSelectedPoint(idx);
    setPopup(true);
    setForm({
      escalation_reason: "",
      escalation_count: "",
      escalation_time: "",
      escalation_status: "",
    });
  };

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  useEffect(() => {
    const fetchEscalations = async () => {
      try {
        const id = campaignId;
        const res = await axios.get(
          `${baseUrl}/api/escalate/getEscalation/${id}`
        );
      //  console.log("res", res.data);
        setEscalationData(res.data.escalation);
      } catch (err) {
        // Handle error as needed
        console.error("Failed to fetch escalation data", err);
      }
    };
    fetchEscalations();
  }, [campaignId]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Prepare the escalation object for the selected point
    const escalationObj = {
      escalation_reason: form.escalation_reason,
      escalation_count: form.escalation_count,
      escalation_time: form.escalation_time,
      escalation_status: form.escalation_status,
    };

    // Prepare the body as per your schema
    const body = {
      campaign_id: String(campaignId || ""),
      Agreement_Signed: {},
      Invoice_Opened: {},
      Invoice_Approved: {},
      Sent_to_Finance: {},
      Processed: {},
      Paid_to_Creator: {},
    };

    // Set the selected escalation point object
    body[FIELD_KEYS[selectedPoint]] = escalationObj;

    try {
      await axios.post("/api/escalations", body); // Change URL as needed
      setPopup(false);
    } catch (err) {
      // Handle error as needed
      alert("Failed to submit escalation");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="p-4"
      >
        <h2 className="text-lg font-bold mb-4">Update Escalation</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 bg-white rounded shadow">
            <thead className="bg-gray-100">
              <tr className="text-left text-sm text-gray-700">
                <th className="px-4 py-2 border">Escalation Point</th>
                <th className="px-4 py-2 border">Escalation Reason</th>
                <th className="px-4 py-2 border">Escalation Count</th>
                <th className="px-4 py-2 border">Escalation Time</th>
                <th className="px-4 py-2 border">Escalation Status</th>
                <th className="px-4 py-2 border">Action</th>
              </tr>
            </thead>

            <tbody className="text-sm divide-y divide-gray-200">
              {ESCALATION_POINTS.map((point, idx) => {
                const key = FIELD_KEYS[idx];
                const data =
                  escalationData && escalationData[key]
                    ? escalationData[key]
                    : {};
                return (
                  <tr key={idx} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border font-medium text-gray-800">
                      {point}
                    </td>
                    <td className="px-4 py-2 border">
                      {data.reason || "--"}
                    </td>
                    <td className="px-4 py-2 border">
                      {data.escalation_count || "--"}
                    </td>
                    <td className="px-4 py-2 border">
                      {data.escalation_time || "--"}
                    </td>
                    <td className="px-4 py-2 border">
                      {data.escalation_status || "--"}
                    </td>
                    <td className="px-4 py-2 border">
                      <button
                        className="bg-green-300 px-1.5 py-0.5  rounded-md hover:bg-green-400"
                        onClick={() => handleEscalate(idx)}
                      >
                        Escalate
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </motion.div>

      {popup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-xl w-11/12 md:w-2/3 lg:w-1/2 relative">
            <button
              onClick={() => setPopup(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              &#x2715;
            </button>
            <h3 className="text-lg font-semibold mb-4">
              Escalate: {ESCALATION_POINTS[selectedPoint]}
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Escalation Reason
                </label>
                <input
                  type="text"
                  name="escalation_reason"
                  value={form.escalation_reason}
                  onChange={handleChange}
                  required
                  className="w-full border px-3 py-2 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Escalation Count
                </label>
                <input
                  type="number"
                  name="escalation_count"
                  value={form.escalation_count}
                  onChange={handleChange}
                  required
                  className="w-full border px-3 py-2 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Escalation Time
                </label>
                <input
                  type="datetime-local"
                  name="escalation_time"
                  value={form.escalation_time}
                  onChange={handleChange}
                  required
                  className="w-full border px-3 py-2 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Escalation Status
                </label>
                <input
                  type="text"
                  name="escalation_status"
                  value={form.escalation_status}
                  onChange={handleChange}
                  required
                  className="w-full border px-3 py-2 rounded"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Escalations;

